<template>
  <v-slide-item>
    <v-menu
      :close-on-content-click="false"
      bottom
      offset-y
      open-on-hover
      content-class="main-menu-content"
    >
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on" :href="category.href">
          {{ $t('menu.' + category.id) }}
        </v-btn>
      </template>
      <v-list class="main-menu-v-list" v-if="!category.byLanguage">
        <MainMenuSubCategory
          v-for="subcategory of subcategories"
          :key="subcategory.id"
          :categoryId="category.id"
          :subcategory="subcategory"
        />
      </v-list>
      <v-list class="main-menu-v-list" v-if="category.byLanguage">
        <MainMenuLanguage
          v-for="language of languages"
          :key="language.id"
          :categoryId="category.id"
          :language="language"
          :subcategories="subcategories"
        />
      </v-list>
    </v-menu>
  </v-slide-item>
</template>

<script>
import MainMenuSubCategory from '@/components/MainMenuSubCategory'
import MainMenuLanguage from '@/components/MainMenuLanguage'

export default {
  components: { MainMenuSubCategory, MainMenuLanguage },
  props: {
    category: Object,
    subcategories: Object,
    languages: Object,
    href: String
  }
}
</script>
